"use client";
import { Box, Typography } from "@mui/material";
import Image from "next/image";

export default function FeatureCard({ title, description, icon }) {
    return (
        <Box
            sx={{
                width: "100%",
                height: "350px",
                borderRadius: "45px",
                background: "linear-gradient(180deg, #75c4c5 0%, #0d8196 100%)",
                padding: "32px 28px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                boxShadow: "0px 6px 20px rgba(0,0,0,0.12)",
                color: "#FFFFFF",
                overflow: "hidden",
                textAlign: "start"
            }}
        >
            {/* Text Section */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: "18px" }}>
                <Typography
                    variant="h6"
                    sx={{
                        fontWeight: 600,
                        fontSize: "25px",
                        lineHeight: 1.2,
                        letterSpacing: "0.1px",
                        color: "#ffffff",
                        // whiteSpace: "nowrap",
                    }}
                >
                    {title}
                </Typography>

                <Typography
                    variant="body1"
                    sx={{
                        fontWeight: 400,
                        fontSize: "14px",
                        lineHeight: "26px",
                        color: "#ffffff",
                        // maxWidth: "300px",
                        // maxHeight: "300px",
                        // whiteSpace: "nowrap",
                    }}
                >
                    {description}
                </Typography>
            </Box>

            {/* Bottom Icon */}
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "flex-end",
                    mt: 2
                }}
            >
                <Image
                    src={`${process.env.IMAGE_BASE_URL}/${icon}`}
                    alt={title}
                    width={90}
                    height={90}
                    style={{
                        objectFit: "contain",
                        transform: "translateY(10px)",
                    }}
                />
            </Box>
        </Box>
    );
}
